const GREMLIN_KEYWORDS = [
  'E',
  'V',
  'and',
  'as',
  'both',
  'bothE',
  'bothV',
  'dedup',
  'def',
  'filter',
  'get',
  'has',
  'hasLabel',
  'id',
  'in',
  'inE',
  'inV',
  'label',
  'limit',
  'map',
  'next',
  'not',
  'or',
  'orElse',
  'out',
  'outE',
  'outV',
  'path',
  'properties',
  'property',
  'repeat',
  'simplePath',
  'sum',
  'times',
  'toSet',
  'unfold',
  'union',
  'until',
  'values',
  'within',
];

export { GREMLIN_KEYWORDS };
